import Vue from 'vue'
import VueRouter from 'vue-router'
import routes from './routerMap.js'

Vue.use(VueRouter)

const whiteList = ['/login', '/404']
const extraUrl = ['/index','/privateRegister','/nonPrivateRegister']

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  if (!whiteList.includes(to.path)) {
    const userName = sessionStorage.getItem('user_uid')
    if (userName === null) {
      next('/login')
      return
    }
    if(!extraUrl.includes(to.path)){
      const menuRouter = sessionStorage.getItem('menu_router')
      const menuList = JSON.parse(menuRouter)
      const shortPath = to.path.substring(1)
      let paths = []
      for (const one of menuList) {
        for (const child of one.subMenu) {
          paths.push(child.url)
        }
      }
      if (menuRouter !== null) {
        const hasRouter = paths.includes(shortPath)
        if (!hasRouter) {
          next('/404')
        }
      }
    }
  }
  next()
})

export default router
